import React, { useEffect, useState } from 'react';
import Modal from '../../../../../common/Modal';
import { HiSparkles } from 'react-icons/hi2';
import { HiMinus, HiPlus } from 'react-icons/hi';
import { Button } from '../../../../../common/index';
import { Company } from '../../../../../types/generated.types';
import { ManageMode } from '../../../../../types/types';
import ModalCouponsManage from './ModalCouponsManage';
import AutoResizeTextarea from '../../../../../common/AutoResizeTextarea';
import FieldWrapper from '../../../../../common/FieldWrapper';

interface ModalAddCouponsProps {
  isOpen: boolean;
  onClose: () => void;
  company: Company;
  refetchCoupons?: () => void;
}

const ModalAddCoupons: React.FC<ModalAddCouponsProps> = ({ isOpen, onClose, company, refetchCoupons }) => {
  const [quantity, setQuantity] = useState<number>(1);
  const [isGenerateModalOpen, setIsGenerateModalOpen] = useState<boolean>(false);

  const [contexts, setContexts] = useState<string[]>([]);

  useEffect(() => {
    setContexts(prev => {
      // If increasing extend array
      if (quantity > prev.length) {
        return [
          ...prev,
          ...Array.from({ length: quantity - prev.length }, () => '')
        ];
      }

      // If decreasing truncate
      if (quantity < prev.length) {
        return prev.slice(0, quantity);
      }

      // Same length do nothing
      return prev;
    });
  }, [quantity]);

  const handleDecrement = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const handleIncrement = () => {
    if (quantity < 20) {
      setQuantity(quantity + 1);
    }
  };

  const [isCreateModalOpen, setIsCreateModalOpen] = useState<boolean>(false);

  const handleCreateCoupons = () => {
    setIsCreateModalOpen(true);
  };

  const handleCloseCreateModal = () => {
    setIsCreateModalOpen(false);
  };

  const handleCloseGenerateModal = () => {
    setIsGenerateModalOpen(false);
  };

  const handleGenerateSuggestion = () => {
    setIsGenerateModalOpen(true);
  };

  const handleModalSaved = () => {
    // Close both modals
    setIsCreateModalOpen(false);
    setIsGenerateModalOpen(false);
    // Refetch coupons to update the list
    if (refetchCoupons) {
      refetchCoupons();
    }
    // Close AddCouponsModal when coupons are successfully saved
    onClose();
  };

  return (
    <>
      <Modal isOpen={isOpen} closeModal={onClose} className="add-coupons-modal">
        <div className="add-coupons-modal-content flex flex-col items-center gap-2">
          <h4>Hur många kuponger vill du skapa?</h4>

          <div className="quantity-selector flex items-center justify-center gap-2 mb">
            <button
              type="button"
              className="quantity-button secondary flex items-center justify-center"
              onClick={handleDecrement}
              disabled={quantity <= 1}
            >
              <HiMinus size={14} />
            </button>
            <div className="quantity-display text-center">
              {quantity}
            </div>
            <button
              type="button"
              className="quantity-button secondary flex items-center justify-center"
              onClick={handleIncrement}
              disabled={quantity >= 20}
            >
              <HiPlus size={14} />
            </button>
          </div>

          <div className="modal-actions flex flex-col gap-1 justify-center">
            <Button
              type="button"
              className="primary md flex items-center justify-center gap-1"
              onClick={handleCreateCoupons}
            >
              Skapa kuponger
            </Button>
            <p className='seperator'>eller generera kuponger</p>
            <div className="context-section">
              <div className="context-header">Instruktioner till AI (valfritt)</div>

              {Array.from({ length: quantity }).map((_, i) => (
                <AutoResizeTextarea
                  key={i}
                  rows={1}
                  value={contexts[i]}
                  onChange={(v) => {
                    setContexts(prev => {
                      const copy = [...prev];
                      copy[i] = v.target.value;
                      return copy;
                    });
                  }}
                  placeholder={`Instruktioner för Kupong #${(i + 1)}`}
                />
              ))}
            </div>
            <button
              type="button"
              className="primary md flex items-center justify-center gap-1"
              onClick={handleGenerateSuggestion}
            >
              <HiSparkles size={16} />
              Generera förslag
            </button>
          </div>
        </div>
      </Modal>

      <ModalCouponsManage
        isOpen={isGenerateModalOpen}
        onClose={handleCloseGenerateModal}
        onSaved={handleModalSaved}
        quantity={quantity}
        contexts={contexts}
        company={company}
        mode={ManageMode.GENERATE}
        refetchCoupons={refetchCoupons}
      />

      <ModalCouponsManage
        isOpen={isCreateModalOpen}
        onClose={handleCloseCreateModal}
        onSaved={handleModalSaved}
        quantity={quantity}
        company={company}
        mode={ManageMode.ADD}
        refetchCoupons={refetchCoupons}
      />
    </>
  );
}

export default ModalAddCoupons;

